import React from 'react'
import { Navigate, Outlet,useLocation } from 'react-router-dom'
import { IsLoggedIn, isPathAllowed } from "../utils/Common";
 

export default function LogedInOutlet() {

    const {pathname} = useLocation();
    const isAllowed = isPathAllowed(pathname);

    if(IsLoggedIn() && isAllowed) {
        return <Outlet />;
    }
    else if(IsLoggedIn()){
        return <Navigate to="/unauthorized" />
    }
    else {
        return <Navigate to="/login" />
    }
   
}
